import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaterialListControllerService {
  private _materialList: Array<string> = [];
  private _materialList$: BehaviorSubject<Array<string>> = new BehaviorSubject<Array<string>>(
    this.materialList,
  );

  constructor() {}

  get materialList(): Array<string> {
    return this._materialList;
  }

  set materialList(materialList: Array<string>) {
    this._materialList = materialList;
    this._materialList$.next(materialList);
  }

  get materialList$(): BehaviorSubject<Array<string>> {
    return this._materialList$;
  }

  public addMaterial(material: string): void {
    this.materialList.push(material);
    this.materialList$.next(this.materialList);
  }

  public removeMaterial(material: string): void {
    this.materialList = this.materialList.filter((item) => item !== material);
    this.materialList$.next(this.materialList);
  }
}
